import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Input from '@rad/components/inputs/input';
// One color in the theme picker, with its hex value under it.
const ThemeColorField = (props) => {
    return _jsx(_Fragment, { children: _jsxs("div", { children: [_jsx(Input, { kind: "color", value: props.value, label: props.label, className: "w-100", onChange: value => value && props.onChange(value) }), _jsx("div", { className: "small text-body-secondary mt-1", children: props.value })] }) });
};
export default ThemeColorField;
